import { render, staticRenderFns } from "./Productheader.vue?vue&type=template&id=90f44184&scoped=true&"
import script from "./Productheader.vue?vue&type=script&lang=js&"
export * from "./Productheader.vue?vue&type=script&lang=js&"
import style0 from "./Productheader.vue?vue&type=style&index=0&id=90f44184&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f44184",
  null
  
)

export default component.exports